/* ABYSSAL KIOSK — interacciones (sin librerías) */

function ak_initReveal() {
  var els = document.querySelectorAll('.ak-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('ak-in'); });
    return;
  }
  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('ak-in');
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }
  );
  els.forEach(function (el) { io.observe(el); });
}

/* Reloj en hora de Tokio — guiño japonés del header/footer */
function ak_initClock() {
  var els = document.querySelectorAll('[data-ak-clock]');
  if (!els.length) return;
  function tick() {
    var now = new Date();
    var txt;
    try {
      txt = new Intl.DateTimeFormat('es-ES', {
        timeZone: 'Asia/Tokyo',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      }).format(now);
    } catch (e) {
      txt = now.toTimeString().slice(0, 8);
    }
    els.forEach(function (el) { el.textContent = txt; });
  }
  tick();
  setInterval(tick, 1000);
}

/* Galería de la página de producto */
function ak_initGallery() {
  var wraps = document.querySelectorAll('[data-ak-gallery]');
  wraps.forEach(function (wrap) {
    var main = wrap.querySelector('[data-ak-gallery-main]');
    var thumbs = wrap.querySelectorAll('[data-ak-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        if (!full) return;
        main.style.opacity = '0';
        setTimeout(function () {
          main.src = full;
          main.style.opacity = '1';
        }, 140);
        thumbs.forEach(function (t) { t.removeAttribute('data-active'); });
        thumb.setAttribute('data-active', 'true');
      });
    });
  });
}

/* Selector de variantes */
function ak_initVariants() {
  var forms = document.querySelectorAll('[data-ak-product-form]');
  forms.forEach(function (form) {
    var dataEl = form.querySelector('[data-ak-variants]');
    if (!dataEl) return;
    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    var pickers = form.querySelectorAll('[data-ak-option]');
    if (!pickers.length) return;
    var idInput = form.querySelector('input[name="id"]');
    var priceEl = document.querySelector('[data-ak-price]');
    var submit = form.querySelector('[data-ak-submit]');

    function update() {
      var chosen = [];
      pickers.forEach(function (p) {
        var active = p.querySelector('[data-ak-value][data-active="true"]');
        chosen.push(active ? active.getAttribute('data-ak-value') : null);
      });
      var variant = variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === chosen[i]; });
      });
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = variant.price;
      if (submit) {
        if (variant.available) {
          submit.disabled = false;
          submit.textContent = submit.getAttribute('data-label-add') || 'Añadir';
        } else {
          submit.disabled = true;
          submit.textContent = submit.getAttribute('data-label-sold') || 'Agotado';
        }
      }
    }

    pickers.forEach(function (p) {
      p.querySelectorAll('[data-ak-value]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          p.querySelectorAll('[data-ak-value]').forEach(function (b) {
            b.removeAttribute('data-active');
          });
          btn.setAttribute('data-active', 'true');
          update();
        });
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  ak_initReveal();
  ak_initClock();
  ak_initGallery();
  ak_initVariants();
});
